import { createSelector } from '@reduxjs/toolkit';
import { selectJsonQuery } from './selectJsonQuery';
import { getTermsValue } from '../../../packages/JsonQuery';

export const selectHeatingType = createSelector(selectJsonQuery, jsonQuery =>
  getTermsValue('heating_source_type')(jsonQuery),
);
